import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {PaymentService} from '../../services/payment.service';
import {Payment} from '../../model/Entities/Payment';
import {DialogService} from '../../services/dialog.service';
import {DocumentPaymentsResultsDialogComponent, PaymentMatchingResult} from '../DocumentPaymentsResultsDialogComponent/document-payments-results.dialog.component';

@Component({
    selector: 'document-payments-upload-dialog',
    templateUrl: './document-payments-upload.dialog.component.html',
    styleUrls: ['./document-payments-upload.dialog.component.scss']
})
export class DocumentPaymentsUploadDialogComponent implements OnInit {

    private file: Payment = new Payment();
    private fileData: string;

    fileLoaded = false;
    fileUploading = false;
    fileName: string = null;

    @ViewChild('fileInput') fileInput: ElementRef;

    constructor(public dialog: MatDialogRef<DocumentPaymentsUploadDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                protected paymentService: PaymentService,
                private dialogService: DialogService) {
    }

    ngOnInit(): void {
    }

    save(): void {
        this.fileUploading = true;
        this.paymentService.save(this.file).subscribe((response: any) => {
            this.fileUploading = false;

            const results: PaymentMatchingResult[] = (response.data || response || []).map((item: any) => {
                let formattedDate = '';
                if (item.booking_date) {
                    const dateParts = item.booking_date.split('-');
                    if (dateParts.length === 3) {
                        formattedDate = `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
                    }
                }

                return {
                    invoice: item.invoice || null,
                    payment_type: item.payment_type || '',
                    booking_date: formattedDate,
                    counterparty: item.counterparty || '',
                    counterparty_account_number: item.counterparty_account_number || '',
                    variable_symbol: item.variable_symbol || '',
                    amount: item.amount || 0,
                    matching_result: item.matching_result || ''
                };
            });

            this.dialogService.showDialog(DocumentPaymentsResultsDialogComponent, {
                results: results
            }, 1400, 900);
            this.dialog.close(true);
        });
    }

    openFileDialog(): void {
        this.fileLoaded = false;
        this.fileName = null;
        if (this.fileInput) {
            this.fileInput.nativeElement.click();
        }
    }

    fileInputChanged(event: any): void {
        this.readFileFromInput(event.target);
    }

    readFileFromInput(inputValue: any): void {
        const file: File = inputValue.files[0];
        const fileReader: FileReader = new FileReader();

        fileReader.onloadend = (e) => {
            this.fileLoaded = true;
            this.fileName = file.name;
            this.fileData = fileReader.result as string;

            this.file.setFileContent(fileReader.result as string, file.name);
        };
        fileReader.readAsDataURL(file);
    }
}




// WEBPACK FOOTER //
// /app/src/DocumentsModule/DocumentPaymentsUploadDialogComponent/document-payments-upload.dialog.component.ts